import React, { Component } from 'react';
import { useContext, useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Cookies from 'universal-cookie';

import Adminheader from './Adminheader';
import Adminsidebar from './Adminsidebar';
import Editsettingmodal from "./Editafflicatemodal";
import Addsettingmodal from "./Addsettingmodal";
import { Setaffiliatefee, getAffMin, getAffMax } from '../../hooks/useContract';


import Web3 from "web3";
import '../../css/styles.css';

import coin from "../../images/coin.png"
import favicon from "../../images/chainpad/logo.png"

import loader from "../../images/loader.gif"
import { Dropdown, Nav, Tab, Row, Col, Container, ProgressBar, InputGroup, Form } from 'react-bootstrap';
import { getaffhook } from '../../hooks/usebackend';

const cookies = new Cookies();
class Adminsettings extends Component {

    showLoader() {
        document.getElementsByTagName("body")[0].classList.add("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 0.5;
        document.getElementById("loader_div").classList.remove("d-none");
        document.getElementById("loader_div").classList.add("d-block");


    }

    hideLoader() {
        document.getElementsByTagName("body")[0].classList.remove("overflow_hidden");
        document.getElementById("logo_overlay").style.opacity = 1;
        document.getElementById("loader_div").classList.remove("d-block");
        document.getElementById("loader_div").classList.add("d-none");



    }

    // componentDidMount() {
    //     this.restrict()
    //     // this.showLoader();
    //     this.hideLoader();

    //     this.getaff()

    // }




    restrict = async () => {
        var email = cookies.get('cryp-launch-admin-email');
        console.log("email", email);
        if (!email) {
            this.props.history.push("/login")
        }
    }

    getaff = async () => {

        let get = await getaffhook();
        console.log("get", get);
        if (get?.data?.status == true) {
            this.setState({ "getaff": get?.data?.data });
        }
    }


    // handlenextpage = async () => {
    //     let payload = {
    //         limit: this.state.limit,
    //         skip: this.state.skip + this.state.limit
    //     }
    //     let result = await getsettinghook(payload);
    //     if (result?.data?.success == true) {
    //         this.setState({ "settings": result?.data?.data });
    //     }
    //     if (this.state.currentpage % 5 == 0) {
    //         this.setState({ "button": this.state.button + 5 })
    //         // if(this.state.pagecount )
    //     }
    //     this.setState({ "skip": this.state.skip + this.state.limit })
    //     this.setState({ "currentpage": this.state.currentpage + 1 })
    // }

    // handleprevpage = async () => {
    //     let payload = {
    //         limit: this.state.limit,
    //         skip: this.state.skip - this.state.limit
    //     }
    //     let result = await getsettinghook(payload);
    //     if (result?.data?.success == true) {
    //         this.setState({ "settings": result?.data?.data });
    //     }
    //     if ((this.state.currentpage - 1) % 5 == 0) {
    //         this.setState({ "button": this.state.button - 5 })
    //         // if(this.state.pagecount )
    //     }
    //     this.setState({ "skip": this.state.skip - this.state.limit });
    //     this.setState({ "currentpage": this.state.currentpage - 1 });
    // }

    // handlenumpage = async (val) => {
    //     this.setState({ "currentpage": parseInt(val) })
    //     let payload = {
    //         limit: this.state.limit,
    //         skip: (parseInt(val) * 10) - 10
    //     }

    //     let result = await getsettinghook(payload);
    //     if (result?.data?.success == true) {
    //         this.setState({ "settings": result?.data?.data });
    //     }
    //     this.setState({ "skip": (parseInt(val) * 10) - 10 })

    // }

    constructor(props) {
        super(props);
        this.state = {
            afflicatesettingModal: false,
            addsettingModal: false,
            settings: [],
            getaff: [],
            singlesetting: {},
            image: null,
            skip: 0,
            limit: 10,
            pagecount: 0,
            button: 0,
            currentpage: 1,
            affid: {},
            stepcount: 5,
            minAffiliate: 0,
            maxAffiliate: 0,
        };
    }

    onDismiss() {
        this.setState({ afflicatesettingModal: false });
    }

    onDismissAdd() {
        this.setState({ addsettingModal: false });
    }



    componentDidMount() {
        this.restrict()
        this.hideLoader();
        this.fetchData()
    }


    async fetchData() {
        let minFee = await getAffMin()
        let maxFee = await getAffMax()
        minFee = parseFloat(minFee) / 10 ** 18
        maxFee = parseFloat(maxFee) / 10 ** 18
        this.setState({ minAffiliate: minFee })
        this.setState({ maxAffiliate: maxFee })
    }

    render() {


        const location = this.props.location.pathname.split('/')[1];

        const { afflicatesettingModal, addsettingModal } = this.state

        return (
            <div id="loader_main">
                <div id="loader_div">
                    <span className="spin_round">

                    </span>
                    <img src={favicon} className="logo_load" />
                </div>
                <div className='logo_overlay' id="logo_overlay">


                    <Adminheader />

                    <div className="whole_sec pb-5">
                        <div className='flex_side_right adminisideright'>
                            <Adminsidebar />
                            {/* ongoing_sec */}
                            <div className='right_side_sec adminside'>

                                <div className="right_side_spacing">
                                    <div className='ongoing_sec proj_bg pb-5'>
                                        <div className="container px-1">
                                            <div className='top_heqad_sec mt-5 mt-md-0'>

                                                <div className="row">
                                                    <div className="col-12 col-md-6 flex_cen_col mt-md-5 mb-md-4">
                                                        <p className="banner_subtitle form_subhead">Affiliate List</p>

                                                        {/* <hr className='hr_yellow mt-5'/> */}
                                                    </div>
                                                    <div className="col-12 col-md-6 flex_cen_col mt-md-5 mb-md-4">
                                                        <div className='text-right'>
                                                            {/* <button className="get-started-btn btn_width_auto" onClick={() => this.setState({ addsettingModal: true })}>Add</button> */}
                                                        </div>
                                                    </div>

                                                </div>


                                                <div className="inner_bg">
                                                    <div className="container px-1">
                                                        {/* <div class="table-responsive">
                                                            <table className="table recepients_table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>CMS Name</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tr>
                                                                    <td>Banner Image</td>
                                                                    <td className="d-flex justify-content-start"><a className="link_text" onClick={() => {
    
                                                                        this.setState({ afflicatesettingModal: true });
                                                                    }
                                                                    }> Edit</a></td>
                                                                </tr>
                                                            </table>
                                                        </div> */}


                                                        <div className='row det'>
                                                            <div class="col-12 col-md-10 col-lg-9 mx-auto">
                                                                <div class="tab_img">
                                                                    <div className='card_bg card'>
                                                                        <div className='card-body'>
                                                                            <div className='row'>
                                                                                <div class="col-12 mb-3">
                                                                                    <p class="input_desc_sm">Minimum Affiliate</p>
                                                                                    <div class="inputs input-groups noearp_input_admin"><div class="datepicker_input input-group">
                                                                                        <input placeholder="Enter Minimum Affiliate" aria-describedby="basic-addon2" id="price" class="form-control" value={this.state.minAffiliate} onChange={(e) => { this.setState({ "minAffiliate": e?.target?.value }) }} />
                                                                                        {/* <span class="input-group-text" id="basic-addon2"><button class="get-started-btn"   onClick={()=>{Setaffiliatefee(this.state.minAffiliate)}}>Update</button></span> */}
                                                                                    </div></div>
                                                                                </div>

                                                                                <div class="col-12 mb-3">
                                                                                    <p class="input_desc_sm">Maximum Affiliate</p>
                                                                                    <div class="inputs input-groups noearp_input_admin"><div class="datepicker_input input-group">
                                                                                        <input placeholder="Enter Maximum Affiliate" aria-describedby="basic-addon2" id="price" class="form-control" value={this.state.maxAffiliate} onChange={(e) => { this.setState({ "maxAffiliate": e?.target?.value }) }} />

                                                                                    </div></div>
                                                                                </div>
                                                                                <span class="input-group-text" id="basic-addon2"><button class="get-started-btn" onClick={() => { Setaffiliatefee(this.state.minAffiliate, this.state.maxAffiliate) }}>Update</button></span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>






                                                        {/* 
                                                        <div class="table-responsive">
                                                            {console.log("this.state.getaff", this.state.getaff && this.state.getaff.length > 0, this.state.getaff)}
                                                            {this.state.getaff && this.state.getaff.length > 0 ?
                                                                <table className="table recepients_table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Affiliate</th>
                                                                            <th>Minimum Affiliate</th>
                                                                            <th>Maximum Affiliate</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    {this.state.getaff && this.state.getaff.length > 0 && this.state.getaff?.map((data, i) => <>
                                                                        <tr>
                                                                            <td>
                                                                                <div className="p-0 table_det">
                                                                                    <span className="table_text">Affiliate Percentage</span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                            <div className="p-0 table_det">
                                                                                    <span className="table_text">{data.minAffiliate}</span>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                            <div className="p-0 table_det">
                                                                                    <span className="table_text">{data.maxAffiliate}</span>
                                                                                </div>
                                                                            </td>

                                                                           {console.log("data",data)}
                                                                            <td className="d-flex justify-content-start"><a className="link_text" onClick={() => {
                                                                                this.setState({ "affid": data})
                                                                                this.setState({ afflicatesettingModal: true });
                                                                            }
                                                                            }> Edit</a></td>

                                                                        </tr>
                                                                    </>
                                                                    )}



                                                                  

                                                                </table> : <p className='no_data_text'>No Data Found</p>}
                                                        </div> */}

                                                    </div>
                                                </div>






                                            </div>
                                        </div>


                                    </div>
                                    {/* end ongoing_sec */}

                                </div>
                            </div>
                        </div>
                    </div>
                    {/* {afflicatesettingModal && <Editsettingmodal data={this.state.affid} onDismiss={() => this.onDismiss()} get={() => this.getaff()} />} */}


                    {/* <Footer /> */}
                </div>
            </div >
        )
    }
}

export default Adminsettings